
import {Component, Vue, Prop} from "vue-property-decorator";
import {globalStore} from "@/store/globalStore";
import {UserAuth} from "@/models/UserAuth";
import {GlobalService} from "@/services/GlobalService";

@Component({
  name: 'HeadReport'
})

export default class HeadReport extends Vue {
  globalStore = globalStore();
  globalServide = GlobalService.getInstance();

  @Prop() title!: string;
  @Prop() subtitle!: string;

  get fecha () {
    return this.globalStore.fecha;
  }

  // get usuario(): any {
  //   return new UserAuth();
  // }
  get usuario(): UserAuth {
    return this.globalStore.user;
  }

  mounted () {
    this.getFecha();
  }

  getFecha() {
    this.globalServide.getFecha();
  }
}
